import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import Header from './components/organisms/Header';
import reportWebVitals from './reportWebVitals';
import { Stores } from './services/store/index';


ReactDOM.render(
  <React.StrictMode>
    <Header title="検索 | いしゅぷれ -異種姦インプレッション-" />
  </React.StrictMode>,
  document.getElementById('header')
);

ReactDOM.render(
  <React.StrictMode>
    <Stores.Provider>
      <App />
    </Stores.Provider>
  </React.StrictMode>,
  document.getElementById('root')
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
